import { preloadVideo } from 'utils'
import { drawToCanvas } from '.'
import { MediaFrame } from '../../../types'

export async function getVideoFrames(source: File | string, fps: number, maxFrames?: number): Promise<MediaFrame[]> {
    const url = typeof source === 'string' ? source : URL.createObjectURL(source)
    const video = await preloadVideo(url)
    const frameDelay = (maxFrames ? Math.round(video.duration / maxFrames) : Math.round(1000 / fps)) / 1000
    const totalFrames = maxFrames || Math.round(video.duration * fps)

    const frames: MediaFrame[] = await new Promise((resolve) => {
        const videoFrames: MediaFrame[] = []
        let currentFrame = 0

        const drawFrame = () => {
            video.pause()
            videoFrames.push({ canvas: drawToCanvas(video, video.videoWidth, video.videoHeight), delay: frameDelay })
            currentFrame++

            if (currentFrame < totalFrames) {
                video.currentTime = (currentFrame / totalFrames) * video.duration
            } else {
                video.onseeked = null
                resolve(videoFrames)
            }
        }

        video.onseeked = drawFrame
        drawFrame()
    })

    if (typeof source !== 'string') {
        URL.revokeObjectURL(url)
    }

    return frames
}
